/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { TypographyVariantsOptions } from '@mui/material/styles';

const TYPOGRAPHY: TypographyVariantsOptions = {
  fontWeightMedium: 600,
  fontWeightRegular: 500,
};

export default TYPOGRAPHY;
